import React from 'react';
import styles from './TextInput.module.css';

export default function TextInput({ label, id, type = 'text', value, onChange, placeholder, required = false }) {
  return (
    <div className={styles.container}>
      <label htmlFor={id} className={styles.label}>{label}</label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={styles.input}
      />
    </div>
  );
} 